export const PERMISSIONS = {
	ACCOUNT: 'ACCOUNT',

	ACCOUNT_PASSPORT: 'ACCOUNT_PASSPORT',
	ACCOUNT_TYPE_CHANGES: 'ACCOUNT_TYPE_CHANGES',

	ACCOUNT_PRODUCT_SHORT: 'ACCOUNT_PRODUCT_SHORT',
	ACCOUNT_PRODUCT_FULL: 'ACCOUNT_PRODUCT_FULL',
	ACCOUNT_PRODUCT_CART: 'ACCOUNT_PRODUCT_CART',
	ACCOUNT_PROVIDER_USER: 'ACCOUNT_PROVIDER_USER',
	ACCOUNT_CLIENT: 'ACCOUNT_CLIENT',

	CREATE_USER: 'CREATE_USER',
	RETRIEVE_USER: 'RETRIEVE_USER',
	UPDATE_USER: 'UPDATE_USER',
	DELETE_USER: 'DELETE_USER',

	CREATE_USER_TYPE: 'CREATE_USER_TYPE',
	RETRIEVE_USER_TYPE: 'RETRIEVE_USER_TYPE',
	UPDATE_USER_TYPE: 'UPDATE_USER_TYPE',
	DELETE_USER_TYPE: 'DELETE_USER_TYPE',

	CREATE_APPLICATION: 'CREATE_APPLICATION',
	RETRIEVE_APPLICATION: 'RETRIEVE_APPLICATION',
	UPDATE_APPLICATION: 'UPDATE_APPLICATION',
	DELETE_APPLICATION: 'DELETE_APPLICATION',

	CREATE_BRAND: 'CREATE_BRAND',
	RETRIEVE_BRAND: 'RETRIEVE_BRAND',
	UPDATE_BRAND: 'UPDATE_BRAND',
	DELETE_BRAND: 'DELETE_BRAND',

	CREATE_PROVIDER: 'CREATE_PROVIDER',
	RETRIEVE_PROVIDER: 'RETRIEVE_PROVIDER',
	UPDATE_PROVIDER: 'UPDATE_PROVIDER',
	DELETE_PROVIDER: 'DELETE_PROVIDER',

	UPDATE_PROVIDER_PARSER_FILE: 'UPDATE_PROVIDER_PARSER_FILE',
	DELETE_PROVIDER_PARSER_FILE: 'DELETE_PROVIDER_PARSER_FILE',

	RETRIEVE_SOURCE_PROVIDER_PARSER_FILE: 'RETRIEVE_SOURCE_PROVIDER_PARSER_FILE',

	RETRIEVE_PROVIDER_BRAND: 'RETRIEVE_PROVIDER_BRAND',
	UPDATE_PROVIDER_BRAND: 'UPDATE_PROVIDER_BRAND',

	CREATE_PROVIDER_USER: 'CREATE_PROVIDER_USER',
	RETRIEVE_PROVIDER_USER: 'RETRIEVE_PROVIDER_USER',
	UPDATE_PROVIDER_USER: 'UPDATE_PROVIDER_USER',
	DELETE_PROVIDER_USER: 'DELETE_PROVIDER_USER',

	RETRIEVE_BRAND_SOURCE: 'RETRIEVE_BRAND_SOURCE',
	RETRIEVE_PROVIDER_SOURCE: 'RETRIEVE_PROVIDER_SOURCE',

	RETRIEVE_PRODUCT_SHORT: 'RETRIEVE_PRODUCT_SHORT',
	RETRIEVE_PRODUCT_FULL: 'RETRIEVE_PRODUCT_FULL',

	CREATE_PRODUCT_CART: 'CREATE_PRODUCT_CART',
	RETRIEVE_PRODUCT_CART: 'RETRIEVE_PRODUCT_CART',
	DELETE_PRODUCT_CART: 'DELETE_PRODUCT_CART',

	CREATE_APPLICATION_USER_RELATION: 'CREATE_APPLICATION_USER_RELATION',
	RETRIEVE_APPLICATION_USER_RELATION: 'RETRIEVE_APPLICATION_USER_RELATION',
	DELETE_APPLICATION_USER_RELATION: 'DELETE_APPLICATION_USER_RELATION',

	RETRIEVE_USER_TYPE_CHANGE: 'RETRIEVE_USER_TYPE_CHANGE',
	UPDATE_USER_TYPE_CHANGE: 'UPDATE_USER_TYPE_CHANGE',

	CREATE_USER_CLIENT: 'CREATE_USER_CLIENT',
	RETRIEVE_USER_CLIENT: 'RETRIEVE_USER_CLIENT',
	UPDATE_USER_CLIENT: 'UPDATE_USER_CLIENT',
	DELETE_USER_CLIENT: 'DELETE_USER_CLIENT',

	CREATE_USER_CLIENT_CONTACT: 'CREATE_USER_CLIENT_CONTACT',
	RETRIEVE_USER_CLIENT_CONTACT: 'RETRIEVE_USER_CLIENT_CONTACT',
	UPDATE_USER_CLIENT_CONTACT: 'UPDATE_USER_CLIENT_CONTACT',
	DELETE_USER_CLIENT_CONTACT: 'DELETE_USER_CLIENT_CONTACT',

	RETRIEVE_SYSTEM_SETTING_TYPE: 'RETRIEVE_SYSTEM_SETTING_TYPE',
	UPDATE_SYSTEM_SETTING_TYPE: 'UPDATE_SYSTEM_SETTING_TYPE',

	RETRIEVE_SYSTEM_SETTING: 'RETRIEVE_SYSTEM_SETTING',
	UPDATE_SYSTEM_SETTING: 'UPDATE_SYSTEM_SETTING',

	RETRIEVE_SYSTEM_SETTING_USER: 'RETRIEVE_SYSTEM_SETTING_USER',
	UPDATE_SYSTEM_SETTING_USER: 'UPDATE_SYSTEM_SETTING_USER',
};
